import { render, staticRenderFns } from "./ClosePanelButton.vue?vue&type=template&id=c7b7124c"
import script from "./ClosePanelButton.vue?vue&type=script&lang=js"
export * from "./ClosePanelButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports